/**
 * @ngdoc component
 * @name gw-transaction-wizard-title
 *
 * @description  This is the default transaction wizard title, this component is empty and can be overridden by a specify project component.
 *
 */
export default {
    bindings: {
        isQuote: '<',
        isPolicyChange: '<',
        isRenewal: '<'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/transactionWizardTitle/index.js
// module id = 1852
// module chunks = 0